import utils from 'utils'

export default class addOperatorDialogCtrl {
    constructor($scope, $uibModalInstance, formvalidateApi, httpRequest, operator, logger) {
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        function init() {
            $scope.operator = {
                certNo: '', // 证件号
                certType: '', // 证件类型 ,
                operatorName: '', // 经办人姓名
            }
            if (operator) {
                $scope.isEdit = true
                Object.assign($scope.operator, operator)
            }
            // httpRequest.get_dictByTypeArr('["cert_type"]').then((res) => {
            //     $scope.dictData = res.data.value
            //     $scope.operator.certType = $scope.operator.certType || res.data.value.cert_type[0].enumCode
            // })
            $scope.dictData = {
                cert_type: [{enumTypeCode: "cert_type", enumName: "身份证", enumCode: "201", remark: null},{enumTypeCode: "cert_type", enumName: "护照", enumCode: "227", remark: null},{enumTypeCode: "cert_type", enumName: "军官证", enumCode: "202", remark: null}]
            }
        }
        init()

        $scope.validateRules = {
            certNo: [{
                erromsg: '证件号码格式不正确',
                condition(value) {
                    if ($scope.operator.certType === '201') {
                        return !utils.regExpTest(value, 'idCard')
                    }
                    if ($scope.operator.certType === '227') {
                        return !utils.regExpTest(value, 'officer')
                    }
                    if ($scope.operator.certType === '202') {
                        return !utils.regExpTest(value, 'passport')
                    }
                    return false
                },
            }],
        }

        $scope.ok = function ok() {
            const flag = formvalidateApi.run('', true)
            if (!flag) {
                return
            }
            if ($scope.isEdit) {
                httpRequest.post_updateOperator($scope.operator).then((res) => {
                    logger.logSuccess('更新经办人成功')
                    $uibModalInstance.close(res.data.value)
                })
            } else {
                httpRequest.post_addOperator($scope.operator).then((res) => {
                    logger.logSuccess('新增经办人成功')
                    $uibModalInstance.close(res.data.value)
                })
            }
        }
    }
}
addOperatorDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'formvalidateApi', 'httpRequest', 'operator', 'logger']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/addOperatorDialogCtrl.js